import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes"; // Add your route string here if needed

export const createOtp = async (payload) => {
  const response = await apiService.post(`${apiRoutes.createOtp}`,payload);
  return response.data;
};

export const verifyOtp = async (payload) => {
  const response = await apiService.post(`${apiRoutes.verifyOtp}`,payload);
  return response.data;
};


